import React, { useCallback } from 'react'

import { ArrowRight, Button, Divider, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, string } from 'prop-types'

import I18n from 'Pods/Shared/I18n'

function PauseOffer({
  onPause,
  onContinueToCancel,
  isPauseLoading = false,
  oneMonth = false,
  locale = 'en',
}) {
  const translate = useCallback(
    (key, options = {}) => I18n.t(
      `subscription_management.pause_offer.${key}`,
      { ns: 'rails', lng: locale, ...options }
    ),
    [locale]
  )

  return (
    <div className="pause-offer">
      <div className="pause-offer__hero">
        <span className="pause-offer__hero-amount">{translate('hero_amount')}</span>
        <span className="pause-offer__hero-caption">{translate('hero_caption')}</span>
      </div>
      <div className="pause-offer__content">
        <h4 className="pause-offer__title">{translate('title')}</h4>
        <p className="cgt-text-medium pause-offer__description">{translate('description')}</p>
        <ul className="pause-offer__benefits">
          <li className="pause-offer__benefit">{translate('benefits.no_extra_charges')}</li>
          <li className="pause-offer__benefit">{translate('benefits.downloads_licensed')}</li>
          <li className="pause-offer__benefit">{translate('benefits.resume_anytime')}</li>
        </ul>
        <Button
          type="primary"
          size="large"
          expand
          actionType="button"
          customClass="pause-offer__pause-button"
          onClick={onPause}
          disabled={isPauseLoading}
        >
          {translate(oneMonth ? 'pause_button_one_month' : 'pause_button')}
        </Button>
        <Divider customClass="pause-offer__divider" />
        <div className="pause-offer__cancel-row">
          <Button
            type="ghost"
            size="small"
            actionType="button"
            customClass="pause-offer__continue-button"
            trailIcon={<Icon svgComponent={ArrowRight} size="tiny" color="dark" />}
            onClick={onContinueToCancel}
            disabled={isPauseLoading}
          >
            {translate('continue_to_cancel')}
          </Button>
        </div>
      </div>
    </div>
  )
}

PauseOffer.propTypes = {
  onPause: func.isRequired,
  onContinueToCancel: func.isRequired,
  isPauseLoading: bool,
  oneMonth: bool,
  locale: string,
}

export default PauseOffer
